var scrollEnded = function scrollEnded(elementTarget) {
  var scrollEndOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return Math.abs(Math.round(elementTarget.offsetHeight + elementTarget.scrollTop) - (elementTarget.scrollHeight - scrollEndOffset)) <= (scrollEndOffset || 1);
};
export default scrollEnded;